interface LogoProps {
  /** Tailwind height class controlling the logo size, e.g. "h-7". */
  imgClassName?: string;
  /** Extra classes for the wrapper. */
  className?: string;
  alt?: string;
}

const LOGO_URL =
  "https://public.readdy.ai/ai/img_res/57084c63-f253-4f37-a724-ee8bb824d09c.png";

/**
 * Official Joble logo (mark + wordmark) on a transparent background.
 * Sized by height so it stays crisp at any width.
 */
export default function Logo({
  imgClassName = "h-7",
  className = "",
  alt = "Joble",
}: LogoProps) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      title="Joble"
      className={`${imgClassName} w-auto select-none ${className}`}
    />
  );
}